import { Component, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

class RenderBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="bg-white border border-amber-200 rounded-xl p-6 space-y-4">
        <h1 className="text-xl font-semibold">Não foi possível exibir esta página</h1>
        <p className="text-slate-600">
          Os dados continuam salvos. Tente recarregar a página ou volte à base de leads.
        </p>
        <div className="flex gap-3">
          <button className="btn-primary" onClick={() => window.location.reload()}>
            Recarregar página
          </button>
          <Link to="/leads" className="btn-secondary">
            Base de leads
          </Link>
        </div>
      </div>
    );
  }
}
export function PageBoundary({ children }) {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname]);
  return <RenderBoundary key={`${location.pathname}${location.search}`}>{children}</RenderBoundary>;
}
